import React, { useState, useEffect, Fragment } from 'react';
import Header from '../../components/header';
import Card from '../../components/card';
import TableCompare from '../../components/table';
import ElTabs from '../../components/elTabs';
import AtresBarChart from '../../components/charts/atresBarChart';
import Select from '../../components/select';
import { TYPES, SUBTYPES } from '../../envs/core';
import { ResultProvider } from '../../dataProvider/results';
import { getResultOrigin } from '../../dataProvider/origin';
import {
  PlacesProvider,
  getPlace,
  getExcludes
} from '../../dataProvider/places';
import './details.scss';
import { getTitle, navigateTo } from '../../utils';

import Button from '../../components/button/index';

const Details = ({ match, history }) => {
  const {
    year,
    type,
    electionNumber,
    province,
    town,
    placesIds,
    reload
  } = match.params;

  const title = getTitle(type, year);

  const [elSubtype, setElSubtype] = useState(
    type === TYPES.GENERAL ? SUBTYPES.CONGRESS : SUBTYPES.SINGLE
  );

  const [resultOrigin, setResultOrigin] = useState({});

  const [excludes, setExcludes] = useState(null);

  useEffect(() => {
    getExcludes().then(setExcludes);
  }, []);

  useEffect(() => {
    getResultOrigin(year, type, electionNumber, placesIds)
      .then(historicResult => {
        setResultOrigin(historicResult);
      })
      .catch(err => {});
  }, [year, type, electionNumber]);

  useEffect(() => {
    if (town === 'null') {
      getPlace(
        `type=TOWN&parentid=${province}&size=1000&page=0&sortby=population`
      ).then(towns => {
        if (towns && towns.content) {
          const orderedTowns = towns.content.sort((a, b) => {
            if (a.population < b.population) {
              return 1;
            }
            if (a.population > b.population) {
              return -1;
            }
            return 0;
          });
          const child = orderedTowns[0];
          navigateTo(
            history,
            reload,
            `/${placesIds}/${reload}/${year}/${type}/${electionNumber}/${province}/${child.ineId}/detalle.html`,
            child,
            true
          );
        }
      });
    }
  }, [province, town]);

  const changeSubType = subtype => {
    setElSubtype(subtype);
  };

  const changeProvince = (parent, child, fromMap) => {
    navigateTo(
      history,
      false,
      `/${placesIds}/${reload}/${year}/${type}/${electionNumber}/${
        child.ineId
      }/${null}/detalle.html`,
      child,
      true,
      excludes
    );
  };

  const changeLocation = (parent, child, fromMap) => {
    navigateTo(
      history,
      reload,
      `/${placesIds}/${reload}/${year}/${type}/${electionNumber}/${child.parentId}/${child.ineId}/detalle.html`,
      child,
      true,
      excludes
    );
  };

  return resultOrigin && resultOrigin.primary ? (
    <ResultProvider
      electionPlace={placesIds}
      year={year}
      active={resultOrigin.primary.active}
      type={type}
      subtype={elSubtype}
      electionNumber={electionNumber}
      placeId={town === 'null' ? null : town}
      details={true}
    >
      {dataResult => (
        <div className="pageDetails pageDetailsDefault">
          <Header>
            <h2>
              <span className="featured">10-N</span> {title}
            </h2>
          </Header>
          <div className="mainWrapper">
            <div className="colContainer">
              <div className="floatingBlock left">
                <div className="inner">
                  <div className="mapSelectorContainer">
                    {type === TYPES.GENERAL && (
                      <div className="buttonsContainer">
                        <Fragment>
                          <Button
                            className={
                              elSubtype === SUBTYPES.CONGRESS ? 'current' : ''
                            }
                            onClick={() => changeSubType(SUBTYPES.CONGRESS)}
                          >
                            Congreso
                          </Button>
                          <Button
                            className={
                              elSubtype === SUBTYPES.SENATE ? 'current' : ''
                            }
                            onClick={() => changeSubType(SUBTYPES.SENATE)}
                          >
                            Senado
                          </Button>
                        </Fragment>
                      </div>
                    )}
                  </div>
                  {(elSubtype === SUBTYPES.CONGRESS ||
                    elSubtype === SUBTYPES.SINGLE) && (
                    <div className="graphContainer">
                      <div className="selectsContainer">
                        <PlacesProvider
                          type="PROVINCE"
                          parentId={type === TYPES.REGIONAL ? 'R10' : undefined}
                        >
                          {data => {
                            return (
                              <Select
                                placeholder="Seleccione provincia"
                                items={data}
                                selected={province}
                                onChangeSelection={changeProvince}
                                valueKey="parentId"
                                selectedKey="ineId"
                              />
                            );
                          }}
                        </PlacesProvider>
                        <PlacesProvider type="TOWN" parentId={province}>
                          {data => {
                            return (
                              console.log(
                                data && data.filter(x => x.ineId === town)
                              ),
                              (
                                <Select
                                  placeholder="Seleccione localidad"
                                  items={data}
                                  selected={town}
                                  valueKey="ineId"
                                  selectedKey="ineId"
                                  autoselect={true}
                                  onChangeSelection={changeLocation}
                                />
                              )
                            );
                          }}
                        </PlacesProvider>
                      </div>

                      {dataResult &&
                      dataResult.partiesResult &&
                      town !== 'null' ? (
                        <Fragment>
                          <table className="infoTable">
                            <tbody>
                              <tr>
                                <td className="key">Votos contabilizados: </td>
                                <td className="value votes">
                                  {Number(dataResult.totalVotes).toLocaleString(
                                    'es'
                                  )}
                                </td>
                                <td className="value votes_percent">
                                  {Number(
                                    dataResult.currentCountPercent
                                  ).toLocaleString('es')}
                                  %
                                </td>
                              </tr>
                              <tr>
                                <td className="key">Abstenciones: </td>
                                <td className="value votes">
                                  {Number(
                                    dataResult.abstentionVotes
                                  ).toLocaleString('es')}
                                </td>
                                <td className="value abstention_percent">
                                  {Number(
                                    dataResult.abstentionPercent
                                  ).toLocaleString('es')}
                                  %
                                </td>
                              </tr>
                              <tr>
                                <td className="key">Votos en blanco: </td>
                                <td className="value whites">
                                  {Number(dataResult.whiteVotes).toLocaleString(
                                    'es'
                                  )}
                                </td>
                                <td className="value whites_percent">
                                  {Number(
                                    dataResult.whitePercent
                                  ).toLocaleString('es')}
                                  %
                                </td>
                              </tr>
                              <tr>
                                <td className="key">Votos nulos: </td>
                                <td className="value null">
                                  {Number(
                                    dataResult.invalidVotes
                                  ).toLocaleString('es')}
                                </td>
                                <td className="value null_percent">
                                  {Number(
                                    dataResult.invalidPercent
                                  ).toLocaleString('es')}
                                  %
                                </td>
                              </tr>
                              {dataResult.totalSeats && (
                                <tr>
                                  <td className="key">Total de escaños: </td>
                                  <td className="value votes">
                                    {Number(
                                      dataResult.totalSeats
                                    ).toLocaleString('es')}
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                          <AtresBarChart
                            data={
                              dataResult.partiesResult.filter(
                                current => current.votes > 0
                              ) || []
                            }
                            dataKey="votesPercent"
                            showLabel={true}
                            seatTotal={dataResult.totalSeats || 0}
                            label={true}
                          />
                          <p className="buttonBackContainer">
                            <a
                              href={excludes && excludes['C108']}
                              type="button"
                              className="tag button current"
                              onClick={e => {
                                if (!Boolean(parseInt(reload))) {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  navigateTo(
                                    history,
                                    reload,
                                    `/${placesIds}/${reload}/${year}/${type}/${electionNumber}/resultados.html`
                                  );
                                }
                              }}
                            >
                              Volver
                            </a>
                          </p>
                        </Fragment>
                      ) : (
                        <div>Seleccione una localidad</div>
                      )}
                    </div>
                  )}
                </div>
              </div>
              <div className="floatingBlock right">
                {dataResult && town !== 'null' && (
                  <div className="inner">
                    <Card
                      title="ESCRUTADO:"
                      titleValue={
                        dataResult.updateDate
                          ? `${Number(
                              dataResult.currentCountPercent
                            ).toLocaleString('es')} %`
                          : 'Cargando...'
                      }
                      subtitle={
                        dataResult.updateDate
                          ? `Actualizado a las: ${dataResult.updateDate.slice(
                              0,
                              -3
                            )}`
                          : 'Cargando...'
                      }
                    >
                      {elSubtype !== SUBTYPES.SENATE && (
                        <ElTabs titles={['10N', '28A']}>
                          <div>
                            {dataResult.partiesResult && (
                              <TableCompare
                                details
                                hideSeats={true}
                                data={dataResult.partiesResult}
                                showPerson={elSubtype === SUBTYPES.SENATE}
                                legend={
                                  type === TYPES.GENERAL && [
                                    '*Unidas Podemos: Podemos, IU, En Comú Podem y En Común-Unidas Podemos​',
                                    'Más País: Más País, Més Compromís, Más País EQUO,  M País-CHA-EQUO'
                                  ]
                                }
                              />
                            )}
                          </div>
                          <ResultProvider
                            electionPlace={placesIds}
                            active={resultOrigin.historic.active}
                            year={resultOrigin.historic.year}
                            type={type}
                            subtype={elSubtype}
                            electionNumber={resultOrigin.historic.numElection}
                            placeId={town === 'null' ? null : town}
                            details={true}
                          >
                            {oldData => (
                              <div>
                                {oldData.partiesResult && (
                                  <TableCompare
                                    details
                                    hideSeats={true}
                                    data={oldData.partiesResult}
                                    showPerson={elSubtype === SUBTYPES.SENATE}
                                    legend={
                                      type === TYPES.GENERAL && [
                                        '*UNIDAS PODEMOS: Podemos - IU - Equo - En Comú PODEM - En Común Podemos'
                                      ]
                                    }
                                  />
                                )}
                              </div>
                            )}
                          </ResultProvider>
                        </ElTabs>
                      )}
                    </Card>
                  </div>
                )}
              </div>
            </div>
            {elSubtype === SUBTYPES.SENATE && (
              <div className="senateTable">
                <TableCompare
                  details
                  hideSeats
                  isSenate={elSubtype === SUBTYPES.SENATE}
                  showPerson={elSubtype === SUBTYPES.SENATE}
                  data={dataResult.partiesResult || []}
                />
              </div>
            )}
          </div>
          <div className="mainWrapper">
            <p className="buttonBackContainer">
              <a
                href={excludes && excludes['C108']}
                type="button"
                className="tag button current"
                onClick={e => {
                  if (!Boolean(parseInt(reload))) {
                    e.preventDefault();
                    e.stopPropagation();
                    navigateTo(
                      history,
                      reload,
                      `/${placesIds}/${reload}/${year}/${type}/${electionNumber}/resultados.html`
                    );
                  }
                }}
              >
                Volver
              </a>
            </p>
          </div>
        </div>
      )}
    </ResultProvider>
  ) : (
    <div className="loader">Loading</div>
  );
};

export default Details;
